/* eslint-disable */
import React, { Component } from 'react';
import DuendeTokenManager from '../services/DuendeTokenManager';
import ApiCall from '../services/ApiCall';
import swal from 'sweetalert2';

/**
 * DuendeAuthGuard - Auto refresh token and handle token expiration
 * This component should wrap the main app to monitor token status
 */
class DuendeAuthGuard extends Component {
  state = {
    checkInterval: null
  }

  componentDidMount() {
    // Only monitor if using Duende auth
    if (DuendeTokenManager.isDuendeAuth()) {
      this.startTokenMonitoring();
    }
  }

  componentWillUnmount() {
    this.stopTokenMonitoring();
  }

  /**
   * Start monitoring token expiration
   */
  startTokenMonitoring() {
    // Check every 5 minutes
    const checkInterval = setInterval(() => {
      this.checkAndRefreshToken();
    }, 5 * 60 * 1000);

    // Also check immediately
    this.checkAndRefreshToken();

    this.setState({ checkInterval });
  }

  /**
   * Stop monitoring
   */
  stopTokenMonitoring() {
    if (this.state.checkInterval) {
      clearInterval(this.state.checkInterval);
    }
  }

  /**
   * Check token status and refresh if needed
   */
  async checkAndRefreshToken() {
    try {
      if (!DuendeTokenManager.isDuendeAuth()) {
        return;
      }

      // Check if token is expired
      if (DuendeTokenManager.isTokenExpired()) {
        console.log('Token expired, attempting refresh...');
        await this.refreshToken();
      } 
      // Check if token needs refresh soon (less than 10 minutes)
      else if (DuendeTokenManager.needsRefresh()) {
        console.log('Token expiring soon, refreshing...');
        await this.refreshToken();
      }
    } catch (error) {
      console.error('Error checking token:', error);
    }
  }

  /**
   * Refresh access token using refresh token
   */
  async refreshToken() {
    try {
      const refreshToken = DuendeTokenManager.getRefreshToken();
      
      if (!refreshToken) {
        console.error('No refresh token available');
        await this.handleTokenRefreshFailure();
        return;
      }

      const response = await ApiCall.Duende.refreshDuendeToken(refreshToken);
      
      if (response.data && response.data.access_token) {
        // Store new tokens
        DuendeTokenManager.storeTokens(response.data);
        console.log('Token refreshed successfully');
      } else {
        throw new Error('Invalid token response');
      }
    } catch (error) {
      console.error('Token refresh failed:', error);
      await this.handleTokenRefreshFailure();
    }
  }

  /**
   * Handle token refresh failure - logout user
   */
  async handleTokenRefreshFailure() {
    await swal({
      title: 'Session Expired',
      text: 'Your session has expired. Please login again.',
      type: 'warning',
      confirmButtonText: 'OK'
    });

    // Logout and redirect
    await this.logout();
  }

  /**
   * Logout - revoke token and clear data
   */
  async logout() {
    try {
      const accessToken = DuendeTokenManager.getAccessToken();
      
      if (accessToken) {
        // Try to revoke token
        try {
          await ApiCall.Duende.revokeDuendeToken(accessToken, 'access_token');
        } catch (error) {
          console.error('Error revoking token:', error);
          // Continue with logout even if revoke fails
        }
      }

      // Clear all tokens
      DuendeTokenManager.clearTokens();
      localStorage.removeItem('token');

      // Redirect to login
      window.location = '/astra/#/login';
    } catch (error) {
      console.error('Logout error:', error);
      // Force clear and redirect
      DuendeTokenManager.clearTokens();
      localStorage.removeItem('token');
      window.location = '/astra/#/login';
    }
  }

  render() {
    return this.props.children;
  }
}

export default DuendeAuthGuard;
